import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { Services } from '../components/Services';
import { WhyChooseUs } from '../components/WhyChooseUs';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <div className="min-h-screen bg-gray-50 flex flex-col" data-id="element-244">
      <Navbar data-id="element-245" />
      <main className="flex-grow" data-id="element-246">
        <Hero data-id="element-247" />
        <Services data-id="element-248" />
        <WhyChooseUs data-id="element-249" />
        <Contact data-id="element-250" />
      </main>
      <Footer data-id="element-251" />
    </div>;
}